import * as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Stack from '@mui/material/Stack';

//Nu class
import Andrew_Chang from '../../media/Brothers/Headshots/Nu/Andrew_Chang.jpg';
import Filip_Springer from '../../media/Brothers/Headshots/Nu/Filip_Springer.jpg';
import Jake_Lee from '../../media/Brothers/Headshots/Nu/Jake_Lee.jpg';
import Jason_Li from '../../media/Brothers/Headshots//Nu/Jason_Li.jpg';
import Sabrina_Wilderotter from '../../media/Brothers/Headshots/Nu/Sabrina_Wilderotter.jpg';


const Nu = () => {
  const nuClass = [
    {broname: "Andrew Chang", src: Andrew_Chang, alt: "Andrew Chang", majorGrad: "Biomedical Engineering '24"},
    {broname: "Filip Springer", src: Filip_Springer, alt: "Filip Springer", majorGrad: "Mechanical Engineering '24"},
    {broname: "Jake Lee", src: Jake_Lee, alt: "Jake Lee", majorGrad: "Computer Engineering '25"},
    {broname: "Jason Li", src: Jason_Li, alt: "Jason Li", majorGrad: "Computer Engineering '25"},
    {broname: "Sabrina Wilderotter", src: Sabrina_Wilderotter, alt: "Sabrina Wilderotter", majorGrad: "Biomedical Engineering '24"},
    
  ];
  return (
    <div className = "Classes">
      {nuClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default Nu;